var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 173,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248.08 249.83"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".stepFour_svg__cls-1{fill:#466b8c}.stepFour_svg__cls-2{fill:#806e67}.stepFour_svg__cls-3{fill:#5a89b3}.stepFour_svg__cls-11{fill:#ffc859}.stepFour_svg__cls-12{fill:#ffe38c}.stepFour_svg__cls-15{fill:#ffd599}.stepFour_svg__cls-16{fill:#8c624d}.stepFour_svg__cls-17{fill:#bd8b67}.stepFour_svg__cls-21{fill:#f3f8fa}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stepFour_svg__\\u0421\\u043B\\u043E\\u0439_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stepFour_svg__work_place"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stepFour_svg__Balance_-"
  }, /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-1",
    d: "M171.14 95.67l1.41 7.39a17.8 17.8 0 01-14.16 20.81L41.87 146.05a17.79 17.79 0 01-20.8-14.15l-1.41-7.4a17.8 17.8 0 0020.81 14.16L157 116.48a17.8 17.8 0 0014.14-20.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-2",
    d: "M158.09 27.1l13 68.57A17.8 17.8 0 01157 116.48L40.47 138.66a17.8 17.8 0 01-20.81-14.16l-13-68.56a17.8 17.8 0 0114.1-20.81L137.27 13a17.79 17.79 0 0120.82 14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-3",
    d: "M156.69 19.71l14.45 76A17.8 17.8 0 01157 116.48L40.47 138.66a17.8 17.8 0 01-20.81-14.16L5.2 48.55a17.8 17.8 0 0114.15-20.81L135.87 5.56a17.8 17.8 0 0120.82 14.15z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stepFour_svg__cls-1",
    x: 14.11,
    y: 71.81,
    width: 154.32,
    height: 32.55,
    rx: 9.26,
    ry: 9.26,
    transform: "rotate(-11.5 88.784 87.556)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stepFour_svg__cls-3",
    x: 4.79,
    y: 12.38,
    width: 160.13,
    height: 85.9,
    rx: 10.82,
    ry: 10.82,
    transform: "rotate(-10.78 84.816 55.319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8 9.91l-88.62 55-5-26.19A10.84 10.84 0 018.8 26.09z",
    fill: "#7aa5cc"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-1",
    d: "M147 19.66a6 6 0 01-4.78 7l-33.79 6.43a6 6 0 01-6.1-9.29 5.94 5.94 0 013.85-2.53L140 14.88a6 6 0 017 4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.57 17.3a6 6 0 01-4.78 7L108 30.77A6 6 0 01105.75 19l33.79-6.43a6 6 0 017.03 4.73z",
    fill: "#dbe3e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.68 14.4l-15.15 15.12-6.53 1.25A6 6 0 01105.75 19z",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-1",
    d: "M141.9 78.67l-9.32 1.77a1.18 1.18 0 01-1.39-.94 1.2 1.2 0 01.94-1.39l9.33-1.77a1.19 1.19 0 11.44 2.33zm-18.65 3.55L113.92 84a1.19 1.19 0 11-.44-2.34l9.32-1.77a1.19 1.19 0 01.45 2.33zm-18.66 3.55l-9.33 1.78a1.19 1.19 0 01-.44-2.33l9.33-1.78a1.19 1.19 0 11.44 2.33zm46.48-9.39a1.19 1.19 0 01-.84-2.18 7.21 7.21 0 003.39-6.93 1.2 1.2 0 011-1.31A1.18 1.18 0 01156 67a9.6 9.6 0 01-4.52 9.23 1.43 1.43 0 01-.41.15zm2.2-17.38a1.2 1.2 0 01-1.39-.94l-1.77-9.33a1.19 1.19 0 112.33-.44l1.78 9.32a1.19 1.19 0 01-.95 1.39zm-3.55-18.65a1.2 1.2 0 01-1.39-1L146.56 30a1.19 1.19 0 012.33-.44l1.77 9.33a1.19 1.19 0 01-.94 1.43zM156.78 105.94l-9.25 1.76a1.19 1.19 0 11-.44-2.34l9.24-1.76a1.19 1.19 0 01.45 2.34zm-18.58 3.53l-9.32 1.78a1.19 1.19 0 01-.45-2.33l9.33-1.78a1.19 1.19 0 11.44 2.33zM119.55 113l-9.33 1.78a1.19 1.19 0 11-.44-2.33l9.32-1.78a1.19 1.19 0 01.45 2.33zm-18.66 3.56l-9.33 1.77a1.19 1.19 0 11-.44-2.33l9.33-1.78a1.19 1.19 0 11.44 2.34zm-18.66 3.55l-9.32 1.77a1.19 1.19 0 11-.45-2.33l9.33-1.78a1.19 1.19 0 01.44 2.34zm-18.65 3.55l-9.33 1.77a1.19 1.19 0 11-.44-2.33l9.32-1.77a1.19 1.19 0 01.45 2.33zm-18.66 3.55L35.59 129a1.17 1.17 0 01-1.38-.94 1.19 1.19 0 01.94-1.39l9.33-1.77a1.19 1.19 0 11.44 2.33z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.74,
    y: 49.84,
    width: 87.99,
    height: 22.43,
    rx: 7.49,
    ry: 7.49,
    transform: "rotate(-10.85 86.692 61.038)",
    fill: "#89bae6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.23 49l.76 4a7.6 7.6 0 00-8.74-6.26L49.39 60.53a7.61 7.61 0 00-5.82 9l-.76-4a7.61 7.61 0 015.81-9l71.87-13.77a7.6 7.6 0 018.74 6.24z",
    fill: "#bf3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 53l.12.64a7.6 7.6 0 01-5.8 9L52.44 76.47a7.6 7.6 0 01-8.74-6.26l-.13-.64a7.61 7.61 0 015.82-9l71.86-13.77A7.6 7.6 0 01130 53z",
    fill: "#f24949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.37 35.52A25.37 25.37 0 01161 60.94a25.09 25.09 0 01-8.17-1.35 25.46 25.46 0 01-15.06-13.73 24 24 0 01-1.66-5.17 25.26 25.26 0 01-.53-5.17 24.9 24.9 0 01.24-3.48 25.42 25.42 0 0150.6 3.48z",
    fill: "#e69645"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-11",
    d: "M186.37 32.86A25.37 25.37 0 01161 58.28a25.09 25.09 0 01-8.17-1.35 25.43 25.43 0 01-15.11-13.73 24 24 0 01-1.66-5.2 25.42 25.42 0 0143.18-22.82 24.93 24.93 0 013.34 4.29 25.32 25.32 0 013.79 13.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-12",
    d: "M186.37 32.86a25.57 25.57 0 01-.92 6.82l-32.67 17.25a25.43 25.43 0 01-15.06-13.73l44.86-23.7a25.32 25.32 0 013.79 13.36zM179.24 15.21L136.06 38a25.43 25.43 0 01-.29-8.65l36.49-19.25a25.33 25.33 0 016.98 5.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.9 57.81a25.37 25.37 0 01-25.42 25.42 25.18 25.18 0 01-8.17-1.35 25.44 25.44 0 01-15.05-13.73 24 24 0 01-1.67-5.15 26 26 0 01-.53-5.17 25 25 0 01.24-3.48 25.42 25.42 0 0143.47-14.17 24.93 24.93 0 013.34 4.29 25.23 25.23 0 013.79 13.34z",
    fill: "#d48757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.9 55.15a25.38 25.38 0 01-25.42 25.43 25.48 25.48 0 01-23.22-15.08 24.11 24.11 0 01-1.67-5.18 26 26 0 01-.53-5.17 24.87 24.87 0 01.24-3.47 25.42 25.42 0 0143.47-14.18 25.42 25.42 0 017.13 17.65z",
    fill: "#eea064"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-15",
    d: "M224.9 55.15A25.57 25.57 0 01224 62l-32.69 17.22a25.43 25.43 0 01-15.05-13.72l44.85-23.7a25.17 25.17 0 013.79 13.35zM217.77 37.5l-43.18 22.82a26 26 0 01-.53-5.17 24.87 24.87 0 01.24-3.47l36.49-19.29a25.19 25.19 0 016.98 5.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-16",
    d: "M231.78 227.3l-1.15 7.44a17.79 17.79 0 01-20.3 14.88l-117.23-18a17.8 17.8 0 01-14.88-20.29l1.15-7.44a17.78 17.78 0 0014.88 20.29l117.22 18a17.79 17.79 0 0020.31-14.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-2",
    d: "M242.39 158.32l-10.61 69a17.79 17.79 0 01-20.31 14.88l-117.22-18a17.78 17.78 0 01-14.88-20.29l10.61-69A17.79 17.79 0 01110.27 120l117.23 18a17.79 17.79 0 0114.89 20.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-17",
    d: "M243.54 150.88l-11.76 76.42a17.79 17.79 0 01-20.31 14.88l-117.22-18a17.78 17.78 0 01-14.88-20.29l11.76-76.42a17.8 17.8 0 0120.29-14.88l117.23 18a17.8 17.8 0 0114.89 20.29z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stepFour_svg__cls-16",
    x: 81.87,
    y: 177.19,
    width: 154.32,
    height: 32.55,
    rx: 9.26,
    ry: 9.26,
    transform: "rotate(8.75 159.02 193.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-17",
    d: "M248 140.88l-9.77 63.49a10.82 10.82 0 01-12.34 9.06L89 192.36a10.83 10.83 0 01-9-12.35l9.77-63.49a10.83 10.83 0 0112.35-9l136.78 21.01a10.83 10.83 0 019.1 12.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.55 120.63L85.63 142.87l4.05-26.35a10.83 10.83 0 0112.35-9z",
    fill: "#d99f78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-16",
    d: "M209.9 201.51l-9.38-1.44a1.19 1.19 0 11.36-2.35l9.38 1.44a1.19 1.19 0 01-.36 2.35zm-18.77-2.89l-9.38-1.44a1.19 1.19 0 11.36-2.35l9.38 1.45a1.18 1.18 0 01-.36 2.34zm-18.77-2.89l-9.36-1.44a1.19 1.19 0 11.36-2.35l9.38 1.45a1.18 1.18 0 01-.36 2.34zm46.94 6.69a1.22 1.22 0 01-1-.93 1.2 1.2 0 01.92-1.41 7.19 7.19 0 005.51-5.4 1.19 1.19 0 012.32.54 9.59 9.59 0 01-7.34 7.18 1.26 1.26 0 01-.41.02zm7.9-15.67a1.19 1.19 0 01-1-1.36l1.44-9.38a1.19 1.19 0 112.35.36l-1.45 9.38a1.19 1.19 0 01-1.34 1zm2.89-18.75a1.2 1.2 0 01-1-1.36l1.45-9.38a1.18 1.18 0 112.34.36l-1.44 9.38a1.19 1.19 0 01-1.35 1zM214.75 233l-9.31-1.43a1.18 1.18 0 11.36-2.34l9.31 1.43a1.18 1.18 0 11-.36 2.34zm-18.69-2.87l-9.39-1.45a1.18 1.18 0 11.36-2.34l9.39 1.44a1.19 1.19 0 01-.36 2.35zm-18.77-2.89l-9.39-1.44a1.19 1.19 0 01.36-2.35l9.39 1.44a1.19 1.19 0 01-.36 2.35zm-18.77-2.89l-9.39-1.35a1.19 1.19 0 01.36-2.35l9.39 1.45a1.18 1.18 0 01-.36 2.34zm-18.77-2.89l-9.39-1.44a1.19 1.19 0 01.36-2.35l9.39 1.45a1.18 1.18 0 01-.36 2.34zM121 218.62l-9.39-1.45a1.18 1.18 0 11.36-2.34l9.39 1.44a1.19 1.19 0 01-.36 2.35zm-18.77-2.89l-9.39-1.45a1.18 1.18 0 11.36-2.34l9.39 1.44a1.19 1.19 0 01-.36 2.35z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stepFour_svg__cls-16",
    x: 104.68,
    y: 130.32,
    width: 30.6,
    height: 30.6,
    rx: 8.01,
    ry: 8.01,
    transform: "rotate(56.44 119.985 145.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-12",
    d: "M135.58 149.89L123.43 158a8 8 0 01-11.1-2.25l-1.56-2.36-6.5-9.79c-.14-.22-.27-.44-.39-.67a8 8 0 012.64-10.43l12.16-8.06A8 8 0 01129.3 126a4.6 4.6 0 01.47.62l6.51 9.8 1.55 2.35a8 8 0 01-2.25 11.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-11",
    d: "M135.07 152.25l-12.15 8.07a8 8 0 01-11.1-2.26l-1.57-2.36-6.49-9.79c-.14-.22-.27-.43-.39-.66a8 8 0 012.63-10.43l12.15-8.06a8 8 0 0110.63 1.62 4 4 0 01.47.62l6.5 9.8 1.56 2.35a8 8 0 01-2.24 11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-12",
    d: "M135.76 138.8l-25.51 16.9-6.49-9.79c-.14-.22-.27-.43-.39-.66l25.42-16.87a4 4 0 01.47.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.38 119.37A25.38 25.38 0 01211 144.79a25.48 25.48 0 01-23.22-15.08 24.11 24.11 0 01-1.67-5.18 25.88 25.88 0 01-.53-5.16 24.9 24.9 0 01.24-3.48 25.41 25.41 0 0143.47-14.18 24.89 24.89 0 013.34 4.3 25.21 25.21 0 013.75 13.36z",
    fill: "#95abb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.38 116.71A25.37 25.37 0 01211 142.13a25.18 25.18 0 01-8.17-1.35 25.47 25.47 0 01-15-13.73 23.94 23.94 0 01-1.67-5.18 25.8 25.8 0 01-.53-5.16 24.9 24.9 0 01.24-3.48 25.41 25.41 0 0143.47-14.18 24.89 24.89 0 013.34 4.3 25.21 25.21 0 013.7 13.36z",
    fill: "#cfdee6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stepFour_svg__cls-21",
    d: "M236.38 116.71a25.63 25.63 0 01-.92 6.82l-32.67 17.25a25.47 25.47 0 01-15-13.73l44.85-23.7a25.21 25.21 0 013.74 13.36zM229.25 99.05l-43.18 22.82a25.8 25.8 0 01-.53-5.16 24.9 24.9 0 01.24-3.48l36.5-19.29a25.49 25.49 0 016.97 5.11z"
  }))))));
}
export default SvgStepFour;